import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard que protege rotas exclusivas de administradores
 * Apenas admins podem acessar (colaboradores são bloqueados)
 */
export const adminOnlyGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigate(['/auth/login']);
    return false;
  }

  // Apenas admins podem acessar
  if (authService.isAdmin()) {
    return true;
  }

  // Colaboradores e outros são redirecionados para dashboard
  if (authService.isColaborador()) {
    router.navigate(['/admin/dashboard']);
    return false;
  }

  // Outros usuários são redirecionados
  router.navigate(['/protocol/cover']);
  return false;
};

